export const nl = {
  ContactFormulier: "Contact",
  ContactFormulierTitel: "Contactformulier",
  Mevr: "Mevr.",
  Dhr: "Dhr.",
  UwAanvraagIsVerstuurd: "Uw aanvraag is verstuurd.",
  EmailAdres: "E-mailadres",
  EmailAdresControle: "Herhaal e-mailadres",
  EmailAdresInfoTxt: "Wij gebruiken dit e-mailadres als wij contact met u willen opnemen over uw bericht.",
  MaxLengthMessage: "U heeft het maximaal aantal karakters ingevoerd.",
  GeboorteDatum: "Geboortedatum (dd-mm-jjjj)",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "Er kunnen maximaal {{aantal}} tekens ingevoerd worden.",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Wij hebben uw bericht ontvangen. Wij doen ons best uw bericht binnen 5 werkdagen te beantwoorden.",
  MinimumBedragInfoTxt:
    "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
  NaarOnzeHomepage: "Naar onze homepage",
  Omschrijving: "Omschrijving",
  VerplichtVeldIsNietIngevuldTijdensVerzenden: "Verplicht veld is niet ingevuld tijdens verzenden",
  VulUwGegevensIn: "Vul uw gegevens in",
  Voorletters: "Voorletter(s)",
  Achternaam: "Achternaam",
  Telefoonnummer: "Telefoonnummer",
  Opmerking: "Opmerking"
};
